import { useVisibleButton } from './useVisibleButton';
import { useVisibleLink } from './useVisibleLink';
import useIsHasClothInPrize from './useIsHasClothInPrize';
import { useQuestPrize } from './useQuestPrize';

export const useVisibleFooter = ({ quest }) => {
  const { requiredSegment } = quest;
  const isVisibleButton = useVisibleButton({ quest });
  const isVisibleLink = useVisibleLink({ quest });
  const { mainPrize } = useQuestPrize(quest);
  const isVisibleClothItem = useIsHasClothInPrize(mainPrize);

  return isVisibleButton || requiredSegment || isVisibleLink || isVisibleClothItem;
};
